var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolkswagenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 122,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 47.056c-12.066 0-22.008-10.039-22.008-22.104 0-2.51.483-4.923 1.255-7.24l12.838 25c.193.386.386.58.772.58.483 0 .58-.29.772-.58l5.985-13.32c.096-.193.193-.29.29-.29.193 0 .193.193.29.29l6.08 13.32c.193.386.386.58.772.58.483 0 .58-.29.773-.58l12.837-25c.773 2.22 1.255 4.634 1.255 7.24.097 12.065-9.845 22.104-21.911 22.104zm0-27.8c-.193 0-.193-.192-.29-.289L53.857 4.102a21.344 21.344 0 0 1 14.286 0L61.29 18.967c-.097.097-.097.29-.29.29Zm-7.24 16.12c-.192 0-.192-.193-.289-.29l-11.197-21.62c1.93-3.186 4.826-5.889 8.108-7.82l7.915 17.182c.193.386.386.483.58.483h4.15c.29 0 .483-.097.58-.483L71.52 5.647c3.282 1.834 6.178 4.536 8.108 7.818l-11.1 21.622c-.097.193-.193.29-.29.29-.193 0-.193-.194-.29-.29l-4.246-9.46c-.193-.386-.386-.482-.58-.482h-4.15c-.29 0-.483.096-.58.482l-4.343 9.46c-.096.096-.096.29-.29.29zM61 50.048c13.9 0 25-11.197 25-25S74.9-.048 61-.048s-25 11.197-25 25 11.197 25.096 25 25.096z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolkswagenLogo);
export default __webpack_public_path__ + "static/media/volkswagen-logo.72c5bccb144486e05f9e5616e31fb496.svg";
export { ForwardRef as ReactComponent };